import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import type { Position, Snackbar, SnackbarTypes} from '../../services/snackbar.service'
import { SNACKBAR_DATA, SnackbarService } from '../../services/snackbar.service';
import { BehaviorSubject, from } from 'rxjs';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ui-snackbar',
  standalone: true,
  imports: [CommonModule, MatIconModule,RouterModule],
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  snackbarService = inject(SnackbarService);
  data = inject(SNACKBAR_DATA);
  data$ = new BehaviorSubject<Snackbar[]>(this.data);

  backgroundColor: { [key in SnackbarTypes]: string } = {
    info: 'neutral',
    warning: 'error',
    error: 'error',
    success: 'success',
  } as const;

  trackById(index: number, item: Snackbar) {
    return item.id;
  }

  trackByPosition(_: number, item: { position: Position; items: Array<Snackbar> }) {
    return item.position;
  }

  updateData(data: Array<Snackbar>) {
    this.data$.next(data);
  }
}
